import type {
  BD4TravelEcommerceItem,
  Recommendation,
} from '@/redux/middleware/googleTagManager/types';

export const mapHotelRecommendedDataToEcommerceItem = (
  recommendation: Recommendation
): BD4TravelEcommerceItem => ({
  item_name: recommendation?.hotelName,
  item_id: recommendation?.hotelId,
  item_title: 'Alternative Hotels',
  item_category3: (recommendation.price / recommendation.pax / 100).toFixed(0),
  item_list_name: recommendation?.recoInfo?.placementId,
  // format to Smartseer
  price: Number((recommendation.price / 100).toFixed(0)) || 0,
  index: recommendation.index,
  quantity: 1,
});
